import { Button, Col, message, Modal, Popconfirm, Row, Table, Tabs, Tooltip } from "antd";
import { Fragment, useState } from "react";
import moment from "moment";
import { timeCardService } from "../../../redux/services";

const ModalJustificationRequest = ({
    visible,
    onClose,
    fetchJustifications,
    justificationRequests,
    pontoAjusteRequests,
    approveJustifications,
    loadingRejectAll,
    loadingApproveAll,
}) => {
    const [loading, setLoading] = useState(false);
    const [approvingJustification, setApprovingJustification] = useState(null);
    const [rejectingJustification, setRejectingJustification] = useState(null);
    const [approvingPontoAjuste, setApprovingPontoAjuste] = useState(null);
    const [rejectingPontoAjuste, setRejectingPontoAjuste] = useState(null);
    const [wasRejectedRequest, setWasRejectedRequest] = useState(false);

    const onCloseModal = () => {
        if (onClose) onClose(!wasRejectedRequest, wasRejectedRequest);
    }

    const updateJustificationRequest = (funcionario_id, empresa_id, solicitacao_id, aprovar) => {
        setLoading(true);
        aprovar ? setApprovingJustification(solicitacao_id) : setRejectingJustification(solicitacao_id);

        timeCardService.updateSolicitacaoJustificativa({
            funcionario_id,
            empresa_id,
            solicitacao_id,
            status_aprovacao: aprovar ? 'aprovado' : 'recusado',
        }).then((data) => {
            message.success(`Solicitação de justificativa ${aprovar ? 'aprovada' : 'recusada'} com sucesso!`);
            setLoading(false);
            aprovar ? setApprovingJustification(null) : setRejectingJustification(null);
            if (!aprovar) setWasRejectedRequest(true);
            fetchJustifications();
        })
        .catch((error) => {
            Modal.error({
                title  : "Ocorreu um erro!",
                content: String(error),
            });
            setLoading(false);
            aprovar ? setApprovingJustification(null) : setRejectingJustification(null);
        })
    }

    const updatePontoAjusteRequest = (funcionario_id, empresa_id, solicitacao_id, aprovar) => {
        setLoading(true);
        aprovar ? setApprovingPontoAjuste(solicitacao_id) : setRejectingPontoAjuste(solicitacao_id);

        timeCardService.updateSolicitacaoPontoAjuste({
            funcionario_id,
            empresa_id,
            solicitacao_id,
            status_aprovacao: aprovar ? 'aprovado' : 'recusado',
        }).then((data) => {
            message.success(`Solicitação de marcação ${aprovar ? 'aprovada' : 'recusada'} com sucesso!`);
            setLoading(false);
            aprovar ? setApprovingPontoAjuste(null) : setRejectingPontoAjuste(null);
            if (!aprovar) setWasRejectedRequest(true);
            fetchJustifications();
        })
        .catch((error) => {
            Modal.error({
                title  : "Ocorreu um erro!",
                content: String(error),
            });
            setLoading(false);
            aprovar ? setApprovingPontoAjuste(null) : setRejectingPontoAjuste(null);
        })
    }

    const columnsJustification = [
        {
            title: "Data",
            dataIndex: "data",
            key: "data",
            width: 110,
            render: (_, { data }) => (
                <div>{moment.utc(data).format("DD/MM/YYYY")}</div>
            ),
        },
        {
            title: "Período",
            dataIndex: "inicio",
            key: "hora_inicio",
            width: 160,
            sorter: (a, b) => moment(a.hora_inicio, 'HH:mm:ss').unix() - moment(b.hora_inicio, 'HH:mm:ss').unix(),
            render: (_, { hora_inicio, hora_fim, dia_todo, tipo, sequencia }) => tipo === 'parcial' ? 
                (<div>{`${hora_inicio.slice(0, 5)} até ${hora_fim.slice(0, 5)}`}</div>) : 
                dia_todo ? 'Dia todo' : `Entrada ${sequencia} e Saída ${sequencia}`,
        },
        {
            title: "Justificativa",
            dataIndex: "justificativa",
            key: "justificativa",
            ellipsis: true,
            sorter: (a, b) => a.justificativa?.nome.localeCompare(b.justificativa?.nome),
            render: (_, { justificativa }) => (
                <Fragment>{justificativa?.nome}</Fragment>
            ),
        },
        {
            title: "Empresa",
            dataIndex: "contrato.empresa",
            key: "empresa",
            width: 150,
            ellipsis: true,
            render: (_, { contrato }) => (
                <Fragment>{contrato?.empresa?.nome}</Fragment>
            ),
        },
        {
            title: "Departamento",
            dataIndex: "contrato.departamento",
            key: "departamento",
            width: 150,
            ellipsis: true,
            render: (_, { contrato }) => (
                <Fragment>{contrato?.departamento?.nome}</Fragment>
            ),
        },
        {
            title: "Funcionário",
            dataIndex: "funcionario",
            key: "funcionario",
            width: 150,
            ellipsis: true,
            render: (_, { funcionario }) => (
                <Fragment>{funcionario?.nome}</Fragment>
            ),
        },
        {
            title: "Anexo",
            dataIndex: "contrato.funcionario",
            key: "file_comprovante",
            width: 90,
            ellipsis: true,
            render: (_, { file_comprovante }) => (
                <Tooltip title="Visualizar anexo">
                    <Button type="link" href={file_comprovante} target="_blank">
                    <i class="fas fa-file"></i>
                    </Button>
                </Tooltip>
            ),
        },
        {
            title: "Ações",
            dataIndex: "acoes",
            key: "acoes",
            width: 120,
            render: (_, { uuid, funcionario_id, contrato, id }) => (
                <Row gutter={5}>
                    <Col span={12}>
                        <Tooltip title="Aprovar">
                            <Button
                                ghost
                                loading={approvingJustification === id}
                                disabled={loading}
                                type="primary"
                                shape="circle"
                                icon={<i className="fal fa-check"></i>}
                                onClick={() => updateJustificationRequest(funcionario_id, contrato.empresa_id, id, true)}
                            />
                        </Tooltip>
                    </Col>
                    <Col span={12}>
                        <Tooltip title="Recusar">
                            <Button
                                loading={rejectingJustification === id}
                                disabled={loading}
                                danger
                                shape="circle"
                                icon={<i className="fal fa-times"></i>}
                                onClick={() => updateJustificationRequest(funcionario_id, contrato.empresa_id, id, false)}
                            />
                        </Tooltip>
                    </Col>
                </Row>
            ),
        },
    ];

    const columnsPontoAjuste = [
        {
            title: "Data",
            dataIndex: "data",
            key: "data",
            width: 150,
            render: (_, { data }) => (
                <div>{moment.utc(data).format("DD/MM/YYYY HH:mm")}</div>
            ),
        },
        {
            title: "Batida",
            dataIndex: "data",
            key: "data",
            width: 110,
            render: (_, { batida_tipo, sequencia }) => (
                <div>{`${batida_tipo === 'entrada' ? 'Ent.' : 'Saí.'} ${sequencia}`}</div>
            ),
        },
        {
            title: "Motivo",
            dataIndex: "justificativa",
            key: "justificativa",
            ellipsis: true,
            sorter: (a, b) => a.motivo.localeCompare(b.motivo),
            render: (_, { motivo }) => (
                <Fragment>{motivo}</Fragment>
            ),
        },
        {
            title: "Empresa",
            dataIndex: "contrato.empresa",
            key: "empresa",
            width: 150,
            ellipsis: true,
            render: (_, { contrato }) => (
                <Fragment>{contrato?.empresa?.nome}</Fragment>
            ),
        },
        {
            title: "Departamento",
            dataIndex: "contrato.departamento",
            key: "departamento",
            width: 150,
            ellipsis: true,
            render: (_, { contrato }) => (
                <Fragment>{contrato?.departamento?.nome}</Fragment>
            ),
        },
        {
            title: "Funcionário",
            dataIndex: "funcionario",
            key: "funcionario",
            width: 150,
            ellipsis: true,
            render: (_, { funcionario }) => (
                <Fragment>{funcionario?.nome}</Fragment>
            ),
        },
        {
            title: "Ações",
            dataIndex: "acoes",
            key: "acoes",
            width: 120,
            render: (_, { contrato, funcionario_id, id }) => (
                <Row gutter={5}>
                    <Col span={12}>
                        <Tooltip title="Aprovar">
                            <Button
                                ghost
                                loading={approvingPontoAjuste === id}
                                disabled={loading}
                                type="primary"
                                shape="circle"
                                icon={<i className="fal fa-check"></i>}
                                onClick={() => updatePontoAjusteRequest(funcionario_id, contrato.empresa_id, id, true)}
                            />
                        </Tooltip>
                    </Col>
                    <Col span={12}>
                        <Tooltip title="Recusar">
                            <Button
                                danger
                                loading={rejectingPontoAjuste === id}
                                disabled={loading}
                                shape="circle"
                                icon={<i className="fal fa-times"></i>}
                                onClick={() => updatePontoAjusteRequest(funcionario_id, contrato.empresa_id, id, false)}
                            />
                        </Tooltip>
                    </Col>
                </Row>
            ),
        },
    ];

    return (
      <Modal
        visible={visible}
        title="Solicitações de Justificativa e Marcações Manuais realizadas no App"
        wrapClassName="modal-scroll"
        destroyOnClose={true}
        maskClosable={false}
        width={1180}
        onCancel={onCloseModal}
        onOk={onCloseModal}
        closable={true}
        centered
      >
        <div style={{ marginBottom: 16, justifyContent: "right", display: 'flex', gap: 10 }}>
            <Popconfirm
                placement="topRight" 
                title="Deseja recusar todas as solicitações pendentes?" 
                onConfirm={() => approveJustifications()} 
                okText="Sim" 
                cancelText="Não"
            >
                <Button
                    disabled={loadingRejectAll || loadingApproveAll}
                    loading={loadingRejectAll}
                >
                    Recusar todas
                </Button>
            </Popconfirm>
            <Popconfirm
                placement="topRight" 
                title="Deseja aprovar todas as solicitações pendentes?" 
                onConfirm={() => approveJustifications(true)} 
                okText="Sim" 
                cancelText="Não"
            >
                <Button type="primary"
                    disabled={loadingRejectAll || loadingApproveAll}
                    loading={loadingApproveAll}
                >
                    Aprovar todas
                </Button>
            </Popconfirm>
        </div>
        <Tabs defaultActiveKey={(pontoAjusteRequests.length > 0 && !justificationRequests.length) ? "pontoAjustes" : "justifications"}>
            <Tabs.TabPane tab="Justificativas" key="justifications">
                <Table
                    className="table-justifications-request"
                    rowKey="uuid"
                    locale={{ emptyText: "Nenhuma solicitação de justificativa pendente." }}
                    columns={columnsJustification}
                    dataSource={justificationRequests ?? []}
                />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Marcações" key="pontoAjustes">
                <Table
                    className="table-detalhe-batida"
                    rowKey="uuid"
                    locale={{ emptyText: "Nenhuma solicitação de marcação pendente." }}
                    columns={columnsPontoAjuste}
                    dataSource={pontoAjusteRequests ?? []}
                />
            </Tabs.TabPane>
        </Tabs>
      </Modal>
    );
}

export default ModalJustificationRequest;